import React from 'react';
import classNames from 'classnames/bind';
import properties from '../../../modules/ajio-util/properties';
import styles from './shimmer.pcss';

const cx = classNames.bind(styles);
export default () => {
  return (
    <div className={cx('subscription-main-view-shimmer')}>
       <div className={cx('back-arrow')}>
          <img
            src={`${properties.getProperty(
              'imageBaseUrl'
            )}/static/img/${'subscription-page-back.svg'}`}
          />
        </div>
      <div className={cx('all-container')}>
        <div className={cx('skeleton', 'product-image')}></div>
      </div>
      <div className={cx('description-all-container')}>
        <div className={cx('skeleton', 'info-loader-1')}></div>
        <div className={cx('skeleton', 'info-loader-2')}></div>
        <div className={cx('skeleton', 'info-loader-3')}></div>
        <div className={cx('skeleton', 'info-loader-2')}></div>
        <div className={cx('skeleton', 'info-loader-3')}></div>
      </div>
      <div className={cx('all-container', 'price-container')}>
        <div className={cx('skeleton', 'price-info-loader-1')}></div>
        <div className={cx('skeleton', 'price-info-loader-2')}></div>
        <div className={cx('skeleton', 'price-info-loader-3')}></div>
        <div className={cx('skeleton', 'price-info-loader-4')}></div>
      </div>
      <div className={cx('skeleton', 'description-info-loader-2')}></div>
      <div className={cx('skeleton', 'description-info-loader-3')}></div>
      <div className={cx('description-all-container')}>
        <div className={cx('skeleton', 'description-info-loader-1')}></div>
      </div>
      

      <div className={cx("card-container")}>
      <div className={cx("card")}>
        <div className={cx("skeleton", "avatar")}></div>
        <div className={cx("skeleton","text")}></div>
        <div className={cx("skeleton","text")}></div>
      </div>
      <div className={cx("card")}>
        <div className={cx("skeleton", "avatar")}></div>
        <div className={cx("skeleton","text")}></div>
        <div className={cx("skeleton","text")}></div>
      </div>
    </div>
    <div className={cx("card-container")}>
      <div className={cx("card")}>
        <div className={cx("skeleton", "avatar")}></div>
        <div className={cx("skeleton","text")}></div>
        <div className={cx("skeleton","text")}></div>
      </div>
      <div className={cx("card")}>
        <div className={cx("skeleton", "avatar")}></div>
        <div className={cx("skeleton","text")}></div>
        <div className={cx("skeleton","text")}></div>
      </div>
    </div>
    <div className={cx("card-container")}>
      <div className={cx("card")}>
        <div className={cx("skeleton", "avatar")}></div>
        <div className={cx("skeleton","text")}></div>
        <div className={cx("skeleton","text")}></div>
      </div>
      <div className={cx("card")}>
        <div className={cx("skeleton", "avatar")}></div>
        <div className={cx("skeleton","text")}></div>
        <div className={cx("skeleton","text")}></div>
      </div>
    </div>
    <div className={cx("card-container")}>
      <div className={cx("card")}>
        <div className={cx("skeleton", "avatar")}></div>
        <div className={cx("skeleton","text")}></div>
        <div className={cx("skeleton","text")}></div>
      </div>
      <div className={cx("card")}>
        <div className={cx("skeleton", "avatar")}></div>
        <div className={cx("skeleton","text")}></div>
        <div className={cx("skeleton","text")}></div>
      </div>
    </div>
    </div>
  );
};
